import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { MiViewColors, MiViewFontSize, MiViewJustifyContent } from 'miview-ui/miviewTheme';

export const initialsBlockStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: MiViewJustifyContent.center,
  alignItems: 'center',
  width: '40px',
  minWidth: '40px',
  height: '40px',
  fontSize: MiViewFontSize.large,
  color: MiViewColors.tertiary,
  textAlign: 'center',
  position: 'relative',
};

export const categoryBlockStyle: SxProps<Theme> = {
  background: 'rgb(46, 125, 50)',
  width: '20px',
  height: '20px',
  borderRadius: '20px',
  textAlign: 'center',
  fontSize: MiViewFontSize.xxSmall,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: '0px',
  left: '-10px',
};

export const accordionHeaderStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '2px',
  padding: '0 16px',
  background: 'linear-gradient(to right, rgb(223, 223, 223), rgb(255, 255, 255))',
  borderBottom: `1px solid ${MiViewColors.softGray}`,
  fontSize: MiViewFontSize.small,
};
